/**
 * Christmas snow. Canvas rather than DOM nodes so it costs almost nothing,
 * and it stays off entirely for anyone who prefers reduced motion.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var host = document.querySelector('[data-nova-snow]');
    if (!host) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'nova-snow__canvas';
    host.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var flakes = [];
    var count = Number(host.dataset.novaSnow) || 60;
    var raf;

    resize();
    window.addEventListener('resize', debounce(resize, 200));

    for (var i = 0; i < count; i++) flakes.push(make(true));
    loop();

    // Stop painting when the tab is hidden.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        cancelAnimationFrame(raf);
      } else {
        loop();
      }
    });

    function make(seeded) {
      return {
        x: Math.random() * canvas.width,
        y: seeded ? Math.random() * canvas.height : -10,
        r: 0.8 + Math.random() * 2.2,
        speed: 0.25 + Math.random() * 0.75,
        drift: -0.35 + Math.random() * 0.7,
        alpha: 0.25 + Math.random() * 0.5
      };
    }

    function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.speed;
        f.x += f.drift;

        if (f.y > canvas.height + 10 || f.x < -10 || f.x > canvas.width + 10) {
          flakes[i] = make(false);
          continue;
        }

        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,' + f.alpha + ')';
        ctx.fill();
      }

      raf = requestAnimationFrame(loop);
    }

    function resize() {
      canvas.width = host.offsetWidth;
      canvas.height = host.offsetHeight;
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }
  });
})();
